import React from 'react';
import { WizardStep } from '@zillow/zrs-rental-applications';
import RenderSubStep from '../../RenderSubStep';
import UserNotFound from './UserNotFound';
import UserNotFoundLockedOut from './UserNotFoundLockedOut';
import UserLockedOut from './UserLockedOut';
import IncorrectAnswers from './IncorrectAnswers';
import GenericError from './GenericFailure';
import {
  FORBIDDEN_IP_SUBSTEP,
  FORBIDDEN_IP_SUBSTEP_LABEL,
  FROZEN_ACCOUNT_SUBSTEP,
  FROZEN_ACCOUNT_SUBSTEP_LABEL,
  FROZEN_ACCOUNT_WARNING_SUBSTEP,
  FROZEN_ACCOUNT_WARNING_SUBSTEP_LABEL,
  GENERIC_ERROR_SUBSTEP,
  GENERIC_ERROR_SUBSTEP_LABEL,
  INCORRECT_ANSWERS_SUBSTEP,
  INCORRECT_ANSWERS_SUBSTEP_LABEL,
  THIN_CREDIT_FILE_SUBSTEP,
  THIN_CREDIT_FILE_SUBSTEP_LABEL,
  USER_LOCKED_OUT_SUBSTEP,
  USER_LOCKED_OUT_SUBSTEP_LABEL,
  USER_NOT_FOUND_LOCKED_OUT_SUBSTEP,
  USER_NOT_FOUND_LOCKED_OUT_SUBSTEP_LABEL,
  USER_NOT_FOUND_SUBSTEP,
  USER_NOT_FOUND_SUBSTEP_LABEL,
} from '../../constants/steps';
import FrozenAccount from './FrozenAccount';
import FrozenAccountWarning from './FrozenAccountWarning';
import ForbiddenIp from './ForbiddenIp';
import ThinCreditFile from './ThinCreditFile';

interface ErrorStepProps {
  id: string;
  label: string;
}

export default function ErrorStep({ id, label }: ErrorStepProps) {
  return (
    <WizardStep
      id={id}
      label={label}
      hidden
      render={() => [
        <RenderSubStep
          key={GENERIC_ERROR_SUBSTEP}
          id={GENERIC_ERROR_SUBSTEP}
          label={GENERIC_ERROR_SUBSTEP_LABEL}
          hidden
          render={() => <GenericError id={GENERIC_ERROR_SUBSTEP} />}
        />,
        <RenderSubStep
          key={USER_NOT_FOUND_SUBSTEP}
          id={USER_NOT_FOUND_SUBSTEP}
          label={USER_NOT_FOUND_SUBSTEP_LABEL}
          hidden
          render={() => <UserNotFound id={USER_NOT_FOUND_SUBSTEP} />}
        />,
        <RenderSubStep
          key={USER_NOT_FOUND_LOCKED_OUT_SUBSTEP}
          id={USER_NOT_FOUND_LOCKED_OUT_SUBSTEP}
          label={USER_NOT_FOUND_LOCKED_OUT_SUBSTEP_LABEL}
          hidden
          render={() => <UserNotFoundLockedOut id={USER_NOT_FOUND_LOCKED_OUT_SUBSTEP} />}
        />,
        <RenderSubStep
          key={USER_LOCKED_OUT_SUBSTEP}
          id={USER_LOCKED_OUT_SUBSTEP}
          label={USER_LOCKED_OUT_SUBSTEP_LABEL}
          hidden
          render={() => <UserLockedOut id={USER_LOCKED_OUT_SUBSTEP} />}
        />,
        <RenderSubStep
          key={INCORRECT_ANSWERS_SUBSTEP}
          id={INCORRECT_ANSWERS_SUBSTEP}
          label={INCORRECT_ANSWERS_SUBSTEP_LABEL}
          hidden
          render={() => <IncorrectAnswers id={INCORRECT_ANSWERS_SUBSTEP} />}
        />,
        <RenderSubStep
          key={FROZEN_ACCOUNT_SUBSTEP}
          id={FROZEN_ACCOUNT_SUBSTEP}
          label={FROZEN_ACCOUNT_SUBSTEP_LABEL}
          hidden
          render={() => <FrozenAccount id={FROZEN_ACCOUNT_SUBSTEP} />}
        />,
        <RenderSubStep
          key={FROZEN_ACCOUNT_WARNING_SUBSTEP}
          id={FROZEN_ACCOUNT_WARNING_SUBSTEP}
          label={FROZEN_ACCOUNT_WARNING_SUBSTEP_LABEL}
          hidden
          render={() => <FrozenAccountWarning id={FROZEN_ACCOUNT_WARNING_SUBSTEP} />}
        />,
        <RenderSubStep
          key={FORBIDDEN_IP_SUBSTEP}
          id={FORBIDDEN_IP_SUBSTEP}
          label={FORBIDDEN_IP_SUBSTEP_LABEL}
          hidden
          render={() => <ForbiddenIp id={FORBIDDEN_IP_SUBSTEP} />}
        />,
        <RenderSubStep
          key={THIN_CREDIT_FILE_SUBSTEP}
          id={THIN_CREDIT_FILE_SUBSTEP}
          label={THIN_CREDIT_FILE_SUBSTEP_LABEL}
          hidden
          render={() => <ThinCreditFile id={THIN_CREDIT_FILE_SUBSTEP} />}
        />,
      ]}
    />
  );
}
